import { useEffect, useState } from 'react'

export const useToastPopup = () => {
  const [isShow, setIsShow] = useState(false)

  const closeToast = () => setIsShow(false)
  const openToast = () => setIsShow(true)

  useEffect(() => {
    if (isShow) {
      setTimeout(() => {
        closeToast()
      }, 2000)
    }
  }, [isShow])

  return { isShow, openToast }
}